import { render, staticRenderFns } from "./region-edit-panel.vue?vue&type=template&id=16913cb6&scoped=true"
import script from "./region-edit-panel.vue?vue&type=script&lang=js"
export * from "./region-edit-panel.vue?vue&type=script&lang=js"
import style0 from "./region-edit-panel.vue?vue&type=style&index=0&id=16913cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16913cb6",
  null
  
)

export default component.exports